






























































































import { Component, Prop } from 'vue-property-decorator';
import { StaffEntity } from '@/entities/staff.entity';
import { mapGetters } from 'vuex';
import ThanksBtnPc from '@/components/ViewComponent/Thanks/AddThanksMessage/ThanksBtn/ThanksBtnPc.vue';
import SingleUserBaseMixin from '../single-user-base.mixin';

@Component<UserInfo>({
  components: { ThanksBtnPc },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class UserInfo extends SingleUserBaseMixin {
  currentStaff!: StaffEntity;

  @Prop({ type: Boolean })
  show: boolean;

  get isShowBtn() {
    return this.currentStaff.id === this.getUser.id;
  }

  get isShowNameTrophy() {
    return this.currentStaff.id === this.getUser.id;
  }
}
